var CustomSelect = {
    init : function(selectClass) {
        // Dropdown filter events
        $(selectClass).each(function() {

            var $this = $(this);

            $this.addClass('c-select__hidden');
            $this.wrap('<div class="c-select" />');

            var $custom = $this.parent();
            var $list = $('<div class="c-select__options" />');
            var $styledSelect = $('<div class="c-select__styled" />');

            $custom.append($styledSelect);
            $custom.append($list);
            $styledSelect.html('<span>' + $this.find('option:first').html() + '</span>');

            var $optgroupList = $this.find('optgroup');

            var insertOptionGroup = function ($optGroup, $parent) {
                $('<span class="custom-select-group">'+$optGroup.attr('label')+'</span>').appendTo($parent);
                $optGroup.find('option').each(function (){
                    insertOption($(this), $parent);
                });
            };
            var insertOption = function ($option, $parent) {
                $('<span class="custom-select-item" data-value="'+$option.val()+'">' + $option.text() + '</span>').appendTo($parent);
            }

            if ($optgroupList.length) {
                $optgroupList.each(function() {
                    insertOptionGroup($(this), $list);
                });
            } else {
                $this.find('option').each(function () {
                    insertOption($(this), $list)
                })
            }
            var $listItems = $list.children('span');

            $styledSelect.click(function(event) {
                if($(this).hasClass('active')){
                    CustomSelect._closeSelect($(this));
                }
                else{
                    event.stopPropagation();
                    CustomSelect._openSelect($(this));
                }
            });

            $listItems.click(function(e) {
                e.stopPropagation();
                var value = $(this).attr('data-value');
                $styledSelect.html('<span>' + $(this).text() + '</span>');
                $this.val(value);
                $list.hide();
                $this.trigger('c-select:change', [value])
            });

            $(document).on('click',function() {
                CustomSelect._closeSelect($styledSelect);
            });
        });

        //Close menu when click outside
    },
    _closeSelect : function(elem) {
        elem.removeClass('active').next('.c-select__options').hide();
    },
    _openSelect : function(elem) {
        elem.addClass('active').next('.c-select__options').show();
    }
};